import { useEffect } from 'react';

const SITE = 'https://avto-tarix.uz';
const DEFAULT_TITLE = 'Avto Tarix - Avtomobillar tarixini tekshirish';
const DEFAULT_DESC =
  "Avto Tarix - Avtomobillar tarixini tekshirish uchun ishonchli xizmat. DTP va buzilishlar haqida ma'lumot.";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * Lightweight SEO head updater (no extra deps).
 * Restores defaults on unmount.
 */
export default function SeoHead({
  title,
  description,
  canonical,
  image,
  type = 'website'
}) {
  useEffect(() => {
    const prevTitle = document.title;
    const fullTitle = title
      ? (title.includes('Avto Tarix') ? title : `${title} | Avto Tarix`)
      : DEFAULT_TITLE;

    document.title = fullTitle;
    upsertMeta('name', 'description', description || DEFAULT_DESC);
    upsertMeta('property', 'og:title', fullTitle);
    upsertMeta('property', 'og:description', description || DEFAULT_DESC);
    upsertMeta('property', 'og:type', type);
    upsertMeta('property', 'og:url', canonical || window.location.href);
    upsertMeta('property', 'og:site_name', 'Avto Tarix');
    if (image) {
      upsertMeta('property', 'og:image', image.startsWith('http') ? image : `${SITE}${image}`);
    }
    upsertMeta('name', 'twitter:card', image ? 'summary_large_image' : 'summary');
    upsertMeta('name', 'twitter:title', fullTitle);
    upsertMeta('name', 'twitter:description', description || DEFAULT_DESC);
    if (canonical) upsertLink('canonical', canonical);

    return () => {
      document.title = DEFAULT_TITLE;
      upsertMeta('name', 'description', DEFAULT_DESC);
    };
  }, [title, description, canonical, image, type]);

  return null;
}
